import React from "react";
import { observer } from "mobx-react-lite";
import type { ViewComponent } from "@frui.ts/views";
import FilterView from "views/common/filter";
import Form from "react-bootstrap/Form";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import type DocumentsInventoryViewModel from "viewModels/finance/accountingInventory/documentsInventory/documentsInventoryViewModel";
import { Row } from "react-bootstrap";
import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import { translateGeneral } from "utils/localizations";

const DocumentsInventoryFilters: ViewComponent<DocumentsInventoryViewModel> = observer(({ vm }) => {
  const customFilterButton = (
    <Button iconLeft={IconType.Search} className="btn-form-height" type="submit" disabled={!vm.isFilterValid}>
      {translateGeneral("search")}
    </Button>
  );

  const customResetButton = vm.hasFilterChanges ? (
    <Button iconLeft={IconType.Cross} variant="outline-danger" className="btn-form-height" type="reset">
      {translateGeneral("resetFilter")}
    </Button>
  ) : (
    <></>
  );

  return (
    <FilterView vm={vm} customFilterButton={customFilterButton} customResetButton={customResetButton}>
      <Form.Group as={Row} lg={12} xl={12}>
        <div className="form-group col-md-3 col-sm-6">
          <Form.Label>{vm.translateAttribute("accountingPeriodMonthRange.from")}</Form.Label>
          <AdvancedSelect target={vm} property="fromMonth" items={vm.months} placeholder={translateGeneral("selectFromList")} />
        </div>
        <div className="form-group col-md-3 col-sm-6">
          <Form.Label>{vm.translateAttribute("accountingPeriodMonthRange.to")}</Form.Label>
          <AdvancedSelect target={vm} property="toMonth" items={vm.months} placeholder={translateGeneral("selectFromList")} />
        </div>
      </Form.Group>
    </FilterView>
  );
});

export default DocumentsInventoryFilters;
